import React from "react";
import { ToastContainer } from "react-toastify";

import GiftCardProductEditor from "./components/GiftCardProductEditor";

const GiftCardProductEditorApp = (props) => (
  <>
    <ToastContainer icon={false} />
    <GiftCardProductEditor {...props} />
  </>
);

export default GiftCardProductEditorApp;
